// extracted by mini-css-extract-plugin
export default {"floatingCta":"FloatingCTA_floatingCta__5iByS","floatingCta__text":"FloatingCTA_floatingCta__text__p6LKU"};